const { WEBHOOK_TYPES } = require('@silverfort-nodelibs/common/utils/consts');
const { NOTIFICATION_EVENTS_SETTINGS } = require('../../containers/AlertsManagement/components/AlertsOptionsConsts');

export const WEBHOOKS_EVENTS_SETTINGS = {
    ...NOTIFICATION_EVENTS_SETTINGS
};

export const DEFAULT_WEBHOOK = {
    name: '',
    url: '',
    creationDate: Date.now(),
    activeEvents: {
        [WEBHOOK_TYPES.RISK_LEVEL.id]: true,
        [WEBHOOK_TYPES.NEW_INCIDENT.id]: true,
        [WEBHOOK_TYPES.NEW_INSIGHT.id]: true,
        [WEBHOOK_TYPES.SA_ALERTS.id]: true,
        [WEBHOOK_TYPES.PA_ALERTS.id]: true
    },
    settings: {
        [WEBHOOK_TYPES.RISK_LEVEL.id]: WEBHOOKS_EVENTS_SETTINGS[WEBHOOK_TYPES.RISK_LEVEL.id].defaultSelections,
        [WEBHOOK_TYPES.NEW_INCIDENT.id]: WEBHOOKS_EVENTS_SETTINGS[WEBHOOK_TYPES.NEW_INCIDENT.id].defaultSelections,
        [WEBHOOK_TYPES.NEW_INSIGHT.id]: WEBHOOKS_EVENTS_SETTINGS[WEBHOOK_TYPES.NEW_INSIGHT.id].defaultSelections
    }
};
export const WEBHOOK_EXAMPLE = {
    eventType: 'com.silverfort.risk.newIncident',
    eventId: '613d6714-9457-11ee-b9d1-0242ac120002',
    eventTypeVersion: '1.0',
    eventTime: '2023-12-06T08:59:23.903Z',
    data: {
        id: 'string',
        kind: 'UserBruteForce',
        startTime: '2023-01-02T14: 20:52.077Z',
        endTime: '2023-01-02T15: 21:04.1472',
        authCount: 0,
        status: 'Open',
        sources: [
            {
                type: 'device',
                identifierType: 'ip',
                identifier: '10.0.0.1'
            }
        ],
        destinations: [
            {
                type: 'device',
                identifierType: 'ip',
                identifier: '10.0.0.1'
            }
        ],
        users: [
            {
                identifierType: 'UPN',
                identifier: 'example@silverfort.com'
            }
        ],
        mainEntity: {
            type: 'device',
            identifierType: 'ip',
            identifier: '10.0.0.1'
        },
        severity: 'high'
    }
};
